const companyFeaturesConstants = {
  ACCOUNTING_MODULE: 'accounting_module',
  PHYSICAL_CARD_AVAILABLE: 'physical_card_available',
  USE_CUSTOM_POLICIES: 'use_custom_policies'
};

// Page size for pagination
const DEFAULT_PAGE_SIZE = 25;

const DEFAULT_TABLE_DATA = {
  loaded: false,
  loadedPages: 1,
  pagination: null,
  page: 1,
  pageCursors: {},
  rows: []
}

const DEFAULT_TABLE_QUERY = {
  order_by: '-name',
  per_page: DEFAULT_PAGE_SIZE,
}

const DEFAULT_MODAL_PROPS = { loading: false, open: false };

const systemHashKeysConstants = Object.freeze({
  ADD_MULTIPLE_SUBSCRIPTIONS: '#add-multiple-subscriptions',
  ADD_SINGLE_SUBSCRIPTION: '#add-single-subscription',
  OPEN_BANK_ACCOUNT_DETAILS: '#open-bank-account-popup',
  TRANSACTIONS_INVOICE_MISSING: '#transactions-invoice-missing',
  UNMATCHED_INVOICES: '#unmatched-invoices'
});

const popupSettingsConstants = Object.freeze({
  TRANSACTIONS_INVOICE_MISSING: 'transactions_invoice_missing',
  UNMATCHED_INVOICES: 'unmatched_invoices',
});

const expenseAgentTypeConstants = Object.freeze({
  ADD_NEW_EXPENSE: 'add_new_expense',
  FILL_MISSING_INFO: 'fill_missing_info',
});

// Animation duration (in milliseconds)
const SYSTEM_ANIMATION_DURATION = 300;

export {
  companyFeaturesConstants,
  DEFAULT_MODAL_PROPS,
  DEFAULT_PAGE_SIZE,
  DEFAULT_TABLE_DATA,
  DEFAULT_TABLE_QUERY,
  popupSettingsConstants,
  systemHashKeysConstants,
  SYSTEM_ANIMATION_DURATION,
  expenseAgentTypeConstants,
};
